// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nudh9","placeholdersHeader":"styles_placeholdersHeader__1bob4","editorStyle":"styles_editorStyle__23439","placeholdersBox":"styles_placeholdersBox__1ic91"};